import * as React from "react";
import { forwardRef } from "react";
const SvgMainNavNewContent = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4 4.164v12.033a1.162 1.162 0 001.786.98l9.453-6.015a1.161 1.161 0 000-1.96L5.786 3.184A1.162 1.162 0 004 4.164z" }));
const ForwardRef = forwardRef(SvgMainNavNewContent);
export default ForwardRef;
